import { useAtomValue } from 'jotai';
import { SlidersHorizontalIcon } from 'lucide-react';
import React from 'react';

import { ConditionalRender, Skeleton } from '@crossnokaye/ux-common';

import { equipmentLoadingAtom } from '@/features/equipment-browser/equipment-details/state/equipment-response.state';
import { subcomponentSectionConfigsAtom } from '@/features/equipment-browser/equipment-details/state/related-devices.state';
import { SectionTemplate } from '@/features/equipment-browser/equipment-details/templates/section-template';

import { SubcomponentSection } from './subcomponent-section';

export const EquipmentDetailsSubcomponents = (): React.ReactNode => {
  const isLoading = useAtomValue(equipmentLoadingAtom);
  const subcomponentSectionConfigs = useAtomValue(subcomponentSectionConfigsAtom);

  if (!subcomponentSectionConfigs || subcomponentSectionConfigs.length === 0) return null;
  return (
    <SectionTemplate title={'Subcomponents'} icon={SlidersHorizontalIcon} isLoading={isLoading}>
      <ConditionalRender condition={!isLoading} fallback={<Skeletons />}>
        {subcomponentSectionConfigs.map((sectionConfig, index: number) => (
          <SubcomponentSection
            key={`subcomponents-section-${index}`}
            subcomponents={sectionConfig.subcomponents}
            title={sectionConfig.title}
          />
        ))}
      </ConditionalRender>
    </SectionTemplate>
  );
};

const Skeletons = () => {
  return (
    <div className="mb-stack-sm">
      <Skeleton className="w-full h-8 mb-thin" />
      <Skeleton className="w-full h-32 mb-thin" />
    </div>
  );
};
